import { Row, Col, Switch, Typography } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import './Switch.less';
/**
 * @component Switch.tsx
 * @description Switch to disable and available.
 * @return { component }
 */
interface SwitchComponentProps {
  isEnabled: (isEnabled: boolean) => void;
  value: boolean;
}
function SwitchComponent(props: SwitchComponentProps) {
  const { Title } = Typography;
  const isEnabled = (enable: boolean) => {
    props.isEnabled(enable);
  };
  return (
    <Row gutter={20}>
      <Col>
        <Title className="at-switch__text">Deshabilitado</Title>
      </Col>
      <Col>
        <Switch
          checked={props.value}
          onChange={isEnabled}
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
        />
      </Col>
      <Col>
        <Title className="at-switch__text">Habilitado</Title>
      </Col>
    </Row>
  );
}

export default SwitchComponent;
